<!--
    Header nav icon, exported from Figma 4933-40092 (bell-light).
    Kept as a `nav-` set separate from the app's older icons: these carry the
    comp's line weights (1.25 in a ~22px box, 1.0 in the 18px hamburger), which
    the previous mix did not, and swapping the shared icons would change them
    everywhere else too. `currentColor` so the header controls the colour.
-->
<template>
    <!--
        viewBox is the bell's path bounds padded by half a stroke (0.625) on each
        side. Cropped tight to the paths, the 1.25 stroke on the clapper clipped
        against the bottom edge.
    -->
    <svg aria-hidden="true" focusable="false" width="21.8" height="25.25" viewBox="13.83 0.375 21.8 25.25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5847 19.0108C15.4081 19.0108 14.4512 18.0543 14.4512 16.8702C14.4512 15.9847 14.9899 15.2238 15.7519 14.9002C16.248 14.6904 16.5812 14.2139 16.5812 13.6734V8.75195C16.5812 4.4706 20.228 1 24.7255 1C29.2229 1 32.8698 4.4706 32.8698 8.75195V13.6769C32.8698 14.2174 33.2029 14.6939 33.6991 14.9037C34.4646 15.2273 34.9998 15.9883 34.9998 16.8737C34.9998 18.0543 34.0464 19.0144 32.8662 19.0144H16.5847V19.0108Z" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"/>
    <path d="M27.7911 21.9275C27.7911 23.6237 26.4196 24.9998 24.729 24.9998C23.0385 24.9998 21.6669 23.6237 21.6669 21.9275" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>
</template>
